export default {
  // Mining stats
  mining_maxDepth0: {
    achievement: 'Das ist tief',
    description: 'Maximale Tiefe'
  },
  mining_maxDepth1: {
    achievement: 'Tiefer graben',
    description: 'Maximale Gasriesentiefe'
  },
  mining_maxDepthSpeedrun: {
    achievement: 'Tiefenlauf',
    description: 'Maximale Tiefe in unter 15 Minuten'
  },
  mining_depthDwellerCap0: {
    achievement: 'Gerade nach unten',
    description: 'Maximale Gräbertiefe'
  },
  mining_depthDwellerCap1: {
    achievement: 'Funkenlos',
    description: 'Maximale Gasriesen-Gräbertiefe'
  },
  mining_totalDamage: {
    achievement: 'Zerstörung',
    description: 'Gesamter Schaden verursacht'
  },
  mining_maxDamage: {
    achievement: 'Kraft',
    description: 'Meister Schaden in einem Treffer'
  },
  mining_craftingCount: {
    description: 'Spitzhacken hergestellt'
  },
  mining_scrap: {
    achievement: 'Schrotthaufen',
    description: 'Schrott erhalten'
  },
  mining_oreTotal: {
    achievement: 'Mehr Erz',
    description: 'Erz erhalten'
  },
  mining_oreVariety: {
    achievement: 'Diversität',
    description0: 'Erzarten gefunden',
    description1: 'Erz- und Bodenschatzarten gefunden',
    description2: 'Erz-, Bodenschatz- und Gasarten gefunden',
  },
  mining_coal: {
    achievement: 'Dunkelheit',
    description: 'Kohle erhalten'
  },
  mining_resin: {
    achievement: 'Schwierige Situation',
    description: 'Harz erhalten'
  },
  mining_gasTotal: {
    achievement: 'Hitzkopf',
    description: 'Ziffernsumme der höchsten Gasmengen'
  },
  mining_smoke: {
    achievement: 'Schwer zu sehen',
    description: 'Höchste Rauchmenge'
  },
  mining_enhancementHighest: {
    achievement: 'Vorbereitet',
    description: 'Höchste Aufwertungsstufe'
  },
  mining_craftingWasted: {
    achievement: 'Verschwendet',
    description: 'Stelle eine Spitzhacke her, die nicht besser als die aktuelle sein kann'
  },
  mining_dwellerCapHit: {
    achievement: 'Grundgestein',
    description: 'Erreiche die maximale Gräbertiefe'
  },
  mining_craftingLuck: {
    achievement: 'Millionentreffer',
    description: 'Stelle eine Spitzhacke mit Top 0.0001% Werten her'
  },
  mining_timeSpent: {
    description: 'Zeit verbracht'
  },
  mining_bestPrestige0: {
    description: 'Meiste grüne Kristalle in einem Prestige'
  },
  mining_bestPrestige1: {
    description: 'Meiste gelbe Kristalle in einem Prestige'
  },
  mining_prestigeCount: {
    description: 'Prestigeanzahl'
  },

  // Village stats
  village_maxBuilding: {
    achievement: 'Wolkenkratzer',
    description: 'Gebäude konstruiert'
  },
  village_basicResources: {
    achievement: 'Auf Holz geklopft',
    description: 'Höchste Holz-, Pflanzenfaser- oder Steinmenge'
  },
  village_metal: {
    achievement: 'Rost und Metall',
    description: 'Höchste Metallmenge'
  },
  village_coin: {
    achievement: 'Kapitalist',
    description: 'Goldmünzen erhalten'
  },
  village_water: {
    achievement: 'Aquädukt',
    description: 'Höchste Wassermenge'
  },
  village_knowledge: {
    achievement: 'Genie',
    description: 'Höchste Wissensmenge'
  },
  village_advancedResources: {
    achievement: 'Glänzend',
    description: 'Höchste Hartholz- oder Edelsteinmenge'
  },
  village_blessing: {
    achievement: 'Vorherbestimmt',
    description: 'Segen erhalten'
  },
  village_offering: {
    achievement: 'Nihilist',
    description: 'Opfergaben erhalten'
  },
  village_sacrifice: {
    achievement: 'Schwarzes Loch',
    description: 'Opfer erbracht'
  },
  village_oil: {
    achievement: 'Nehmt ihr Öl!',
    description: 'Höchste Ölmenge'
  },
  village_highestPower: {
    achievement: 'Licht an',
    description: 'Höchste Energie'
  },
  village_minHappiness: {
    achievement: 'Leben in der Hölle',
    description: 'Erreiche minimale Zufriedenheit'
  },
  village_timeSpent: {
    description: 'Zeit verbracht'
  },
  village_bestPrestige0: {
    description: 'Meiste Segen in einem Prestige'
  },
  village_bestPrestige1: {
    description: 'Meiste Aktien in einem Prestige'
  },
  village_prestigeCount: {
    description: 'Prestigeanzahl'
  },

  // Horde stats
  horde_maxZone: {
    achievement: 'Entdecker',
    description: 'Maximale Zone'
  },
  horde_maxDifficulty: {
    description: 'Maximale Schwierigkeit'
  },
  horde_maxZoneSpeedrun: {
    achievement: 'Schnelle Schläge',
    description: 'Maximale Zone in unter 30 Minuten'
  },
  horde_totalDamage: {
    description: 'Gesamter Schaden durch normale Angriffe verursacht'
  },
  horde_maxDamage: {
    achievement: 'Mächtig',
    description: 'Meister Schaden in einem normalen Angriff'
  },
  horde_bone: {
    achievement: 'Hundeliebling',
    description: 'Knochen erhalten'
  },
  horde_monsterPart: {
    achievement: 'Nichts wird verschwendet',
    description: 'Monsterteile erhalten'
  },
  horde_soulCorrupted: {
    achievement: 'Seelenhirte',
    description: 'Korrupte Seelen erhalten'
  },
  horde_maxCorruptionKill: {
    achievement: 'Das Böse herausfordern',
    description: 'Gegner mit der höchsten Korruption besiegt'
  },
  horde_maxMastery: {
    achievement: 'Einseitig begabt',
    description: 'Höchste Meisterungsstufe'
  },
  horde_totalMastery: {
    achievement: 'Diversität',
    description: 'Summe aller Meisterungsstufen'
  },
  horde_blood: {
    achievement: 'Vampir',
    description: 'Blut erhalten'
  },
  horde_courage: {
    achievement: 'Mutig',
    description: 'Courage erhalten'
  },
  horde_trinket: {
    achievement: 'Für alles vorbereitet',
    description: 'Summe aller Schmuck-Seltenheiten'
  },
  horde_unlucky: {
    achievement: 'Pechvogel',
    description: 'Scheitere mit einer 99% Erbstücks-Chance'
  },
  horde_infiniteScore: {
    achievement: 'Gladiator',
    description: 'Summe von besiegten Gegnern mit der höchsten # in endlosen Zonen'
  },
  horde_warzoneInfiniteScore: {
    description: 'Gegner mit höchster # in der endlosen Zone besiegt (Kriegsgebiet)'
  },
  horde_monkeyJungleInfiniteScore: {
    description: 'Gegner mit höchster # in der endlosen Zone besiegt (Affendschungel)'
  },
  horde_loveIslandInfiniteScore: {
    description: 'Gegner mit höchster # in der endlosen Zone besiegt (Liebesinsel)'
  },
  horde_maxItems: {
    description: 'Meiste Ausrüstung verwendet'
  },
  horde_timeSpent: {
    description: 'Zeit verbracht'
  },
  horde_bestPrestige0: {
    description: 'Meiste korrupte Seelen in einem Prestige'
  },
  horde_bestPrestige1: {
    description: 'Meiste Courage in einem Prestige'
  },
  horde_prestigeCount: {
    description: 'Prestigeanzahl'
  },

  // Farm stats
  farm_harvests: {
    achievement: 'Rasenmäher',
    description: 'Gesamte Ernten'
  },
  farm_maxOvergrow: {
    achievement: 'Gärtner',
    description: 'Beste Ernte'
  },
  farm_bestPrestige: {
    achievement: 'Renommiert',
    description: 'Höchstes Pflanzen-Prestige'
  },
  farm_vegetable: {
    achievement: 'Vegetarier',
    description: 'Gemüse erhalten'
  },
  farm_berry: {
    achievement: 'Rote Beere',
    description: 'Beeren erhalten'
  },
  farm_grain: {
    achievement: 'Bäcker',
    description: 'Getreide erhalten'
  },
  farm_flower: {
    achievement: 'Florist',
    description: 'Blumen erhalten'
  },
  farm_gold: {
    achievement: 'Monokel',
    description: 'Gold erhalten'
  },
  farm_care: {
    achievement: 'Wertvolle Pflanzen',
    description: 'Pflanzen gepflegt'
  },
  farm_totalMystery: {
    description: 'Mysterium'
  },

  // Gallery stats
  gallery_beauty: {
    achievement: 'Wunderschön',
    description: 'Schönheit erhalten'
  },
  gallery_converter: {
    achievement: 'Endloser Kreislauf',
    description: 'Konverter erhalten'
  },
  gallery_colorVariety: {
    achievement: 'Farbvielfalt',
    description: 'Farbarten gefunden'
  },
  gallery_cash: {
    achievement: 'Reich',
    description: 'Geld erhalten'
  },
  gallery_bestPrestige: {
    description: 'Meistes Geld in einem Prestige'
  },
  gallery_highestTierIdea: {
    achievement: 'Großhirn',
    description: 'Höchste Ideenstufe angewendet'
  },
  gallery_packageMax: {
    achievement: 'Pappkartonburg',
    description: 'Höchste Paketmenge'
  },
  gallery_redDrumMax: {
    achievement: 'Dam dam dam',
    description: 'Höchste Rote Farbtrommelmenge'
  },
  gallery_shapeComboTotal: {
    achievement: 'Sammler',
    description: 'Formen gesammelt'
  },
  gallery_shapeComboHighest: {
    achievement: 'Genie',
    description: 'Höchste Formenkombo'
  },
  gallery_canvasLevelTotal: {
    achievement: 'Visionär',
    description: 'Gesamte Leinwandstufe'
  },
  gallery_hourglassHighest: {
    achievement: 'Geliehene Zeit',
    description: 'Erreiche 1d an Stundenglaszeit'
  },
  gallery_timeSpent: {
    description: 'Zeit verbracht'
  },
  gallery_prestigeCount: {
    description: 'Prestigeanzahl'
  },

  // Other stats
  school_totalPoints: {
    description: 'Gesamtpunkte erhalten'
  },

  // Meta stats
  meta_totalLevel: {
    achievement: 'Überflieger',
    description: 'Gesamtstufe anderer Erfolge'
  },
  meta_highestGrade: {
    achievement: 'Streber',
    description: 'Beste Schulnote'
  },
  meta_longestOfflineTime: {
    achievement: 'Comeback',
    description: 'Längste Abwesenheit'
  },

  // Custom stats
  custom_hordeBattlepass: {
    description: 'Battlepass-Stufe'
  },
};
